import React, { Component } from "react";

import { setDepthOfPit } from "util/aws-manager";
import Button from "material-ui/Button";
import {
  alertsModificationData,
  updateAlertStatus,
} from "util/aws-manager";
import {
  CardText,
} from "reactstrap";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import FilterModal from './../filterModal/filterModal';
import SearchBox from "components/SearchBox";
import { searchDevices } from "util/aws-manager";
import { highlightNavigatedMenu } from "util/highlightSidebarOption";
import moment from "moment";
import { connect } from "react-redux";
import { filterRecords } from './../filterModal/filterFunction';
import _ from "lodash";
import EnhancedTable from './EnhancedTable';

class AlertModification extends Component {
  currentPath;
  constructor(props) {
    super(props);
    this.state = {
      filterData: []
      // startDate: new Date(),
      // endDate: new Date()
    };
  }

  getData = () => {
    alertsModificationData(this.props.deviceId)
      .then((data) => {
        this.props.updateAlertModification({ data, pageNumber: this.props.alertModification.pageNumber });
        if (this.props.alertFilter.length > 0) {
          let filterData = filterRecords(data, this.props.alertFilter);
          this.props.updateFilterAlertModification({ data: filterData, pageNumber: this.props.alertModificationFilter.pageNumber });
          
        }
        else {
          this.props.updateAlertModification({ data, pageNumber: this.props.alertModification.pageNumber });
          this.props.updateFilterAlertModification({ data, pageNumber: this.props.alertModificationFilter.pageNumber });
        }
        this.props.hideLoader();
      })
      .catch((error) => {
        this.props.hideLoader();
        console.log('error: ', error);
      })
  }

  addAlert = () =>{ 
    if (this.props.alertFilter.length === 0) {
      let data = [{
        condition: { type: "is equals", key: "equal" },
        key: {
          disablePadding: false,
          id: "alertStatus",
          label: "Alert Status",
          numeric: false,
          type: "string",
        },
        value: "Open",
      }];
      this.props.addAlert(data);
    }
  }
  componentDidMount() {
    this.addAlert();
    this.getData();
    this.currentPath = this.props.location.pathname;
  }

  componentWillMount() {
    this.unlisten = this.props.history.listen((location) => {
      this.currentPath = location.pathname;
    });
  }

  componentWillUnmount() {
    this.unlisten();
    this.props.addAlert([]);
  }

  // setStartDate = (date) => {
  //   this.setState({ startDate: date })
  // }
  // setEndDate = (date) => {
  //   this.setState({ endDate: date })
  // }

  render() {
    return (
      <div className="row configuration-page">
        <div className="col-12">
          <div className="jr-card d-sm-flex justify-content-sm-between align-items-sm-center">
            <div className="col-12 col-sm-6 col-lg-10">
              <h1 className="mb-0">Alerts</h1>
            </div>
            <div className="col-12 col-sm-6 col-lg-2">
              {/* Device ID: {this.props.deviceId} */}
            </div>
          </div>
        </div>
        <div className="col-12">
          <FilterModal
            filter={this.props.alertFilter}
            data={this.state.filterData}
            setFilteredData={(data) => {
              this.props.updateFilterAlertModification({ data, pageNumber: 0 });
            }} />
          {/* <DatePicker selected={this.state.startDate} onSelect={(date)=>{this.setStartDate(date);}} onChange={date => this.setStartDate(date)} />
          <DatePicker selected={this.state.endDate} onSelect={(date)=>{this.setEndDate(date);}} onChange={date => this.setEndDate(date)} /> */}
          <div className="row">
            <EnhancedTable
              passDataForFilter={(item) => {
                this.setState({
                  filterData: item,
                })
              }}
              updateAlertStatus={async (data, nodeId) => {
                await this.props.showLoader();
                await this.props.updateAlertModification({ data: [], pageNumber: this.props.alertModification.pageNumber });
                await this.props.updateFilterAlertModification({ data: [], pageNumber: this.props.alertModificationFilter.pageNumber });
                await updateAlertStatus(data, nodeId);
                this.addAlert();
                await this.getData();
              }}
              updateDeviceId={(deviceId) => {
                this.props.updateDeviceId(deviceId);
                if (
                  !(
                    this.currentPath === "/app/components/heartbeat" ||
                    this.currentPath === "/app/components/notifications"
                  )
                ) {
                  highlightNavigatedMenu("heartbeat", `#${this.currentPath}`);
                  this.props.history.push("/app/components/heartbeat");
                }
              }} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ symbioticReducer }) => {
  return {
    deviceId: symbioticReducer.deviceId,
    alertFilter: symbioticReducer.alertFilter,
    alertModification: symbioticReducer.alertModification,
    alertModificationFilter: symbioticReducer.alertModificationFilter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateDeviceId: (id) => {
      dispatch({ type: "UPDATE_DEVICE_ID", deviceId: id });
    },
    updateAlertModification: (data) => {
      dispatch({ type: "ALERT_MODIFICATION_DATA", alertModification: data });
    },
    updateFilterAlertModification: (data) => {
      dispatch({ type: "ALERT_MODIFICATION_FILTER_DATA", alertModification: data });
    },
    showLoader: () => {
      dispatch({ type: "SHOW_OVERALL_APP_LOADER" });
    },
    // Dispatch action to hide loader
    hideLoader: () => {
      dispatch({
        type: "HIDE_OVERALL_APP_LOADER",
      });
    },
    addAlert: (data) => {
      dispatch({
        type: 'ALERT_FILTER',
        alertFilter: data
      });
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertModification);



// WEBPACK FOOTER //
// ./app/routes/alertModification/index.js